/**
 * @component banner
 * @author 陈恩浩
 */

import React, { Component } from "react";
import "./index.scss";
import { changePopup } from "src/redux/basicInfo";
import { connect } from "react-redux";
import Swiper from "swiper";

import { postGetShowBannerList } from "src/apis/home";

import "src/static/swiper/swiper.css";
@connect((state) => state, { changePopup })
class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerList: [],
    };
  }

  handleTrial = () => {
    this.props.changePopup({ type: "trial", status: true });
  };

  handleSkip = (e) => {
    window.open(`${e}`);
  };

  async componentDidMount() {
    let bannerList = (await postGetShowBannerList({})).data;
    this.setState({
      bannerList,
    });
    new Swiper(".swiper-container-banner", {
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next-banner-t",
        prevEl: ".swiper-button-prev-banner-t",
      },
      loop: true,
      autoplay: {
        delay: 10000,
      },
    });
  }

  componentWillUnmount() {}

  handleResize = (e) => {
    // 根据宽度不同，进行你所要进行的操作
    document.getElementById("home-banner").style.width =
      e.target.innerWidth + "px";
    document.getElementById("home-banner").style.height =
      e.target.innerHeight + "px";
  };

  render() {
    let { bannerList } = this.state;
    // console.log(bannerList);
    return (
      <div className="banner-swiper">
        <div className="swiper-container swiper-container-banner">
          <div className="swiper-wrapper">
            {/* <!-- Slides --> */}
            {bannerList.map((item, index) => (
              <div
                style={{
                  cursor: "pointer",
                  backgroundImage: "url(" + item.bannerUrl + ")",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
                className="swiper-slide"
                onClick={() => this.handleSkip(item.skipUrl)}
                key={"bannerSwiperList-" + index}
              ></div>
            ))}
            {/* <!-- Additional required wrapper --> */}
            <div className="home-banner swiper-slide">
              <video className="banner-mp4" autoPlay loop muted>
                <source
                  src="//cdn.ihatoo.com//hatu-official/home/banner/banner.mp4"
                  type="video/mp4"
                />
              </video>
              <div className="popup">
                <div className="text-top">
                  在线学中文 当然选<span className="bold">哈兔</span>
                  <br />
                  <span className="bold">免费</span>领取价值188元试读课
                </div>
                <div className="button" onClick={this.handleTrial}>
                  免费领取
                </div>
                <div className="text-extra">
                  <div className="text-extra-wrap">
                    <div className="img"></div>
                    <div className="text1">央视专题报道</div>
                  </div>
                  <div className="text2">全球55000+海外华人家长共同的选择</div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- If we need navigation buttons --> */}
          <div className="swiper-button-next-banner-t"></div>
          <div className="swiper-button-prev-banner-t"></div>
          {/* <!-- 如果需要分页器 --> */}
          <div className="swiper-pagination"></div>
        </div>
      </div>
    );
  }
}

export default Banner;
